import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedMod } from "../../Redux/actions/settingsActions";

import avatar1 from "../../assets/images/xs/avatar1.jpg";
import avatar4 from "../../assets/images/xs/avatar4.jpg";
import UserImg from "../../assets/images/user.png";
import CommonSetting from "../CommonSetting/CommonSetting";

const CommonHeader = ({ toggleSidebar, toggleSidebarMobile, dynamicClass, hideValue, MenuShow }) => {
  const dispatch = useDispatch();
  const [selectedMode, setSelectedMode] = useState("");

  const setThemeMode = (mode) => {
    setSelectedMode(mode);
  };

  let iconId;
  switch (selectedMode) {
    case "light":
      iconId = "sun-fill";
      break;
    case "dark":
      iconId = "moon-stars-fill";
      break;
    case "auto":
      iconId = "circle-half";
      break;
    default:
      iconId = "sun-fill";
  }

  useEffect(() => {
    dispatch(setSelectedMod(selectedMode));
  }, [selectedMode, dispatch]);


  const location = useLocation();
  const pageTitle = location.pathname
    .replace('/docs', '')
    .replace('/', '')
    .replaceAll("-", ' ')
    || 'Dashboard';

  return (
    <>
      <header className="px-3 sticky-top d-block" id="commonNav" data-bs-theme="none">
        <div className="d-flex align-items-center py-2 row-gap-3 flex-wrap">
          <div className="align-items-center d-flex">
            <button
              className={`btn border-0 p-0 pe-2 ${dynamicClass}`}
              type="button"
              onClick={toggleSidebar}
            >
              <span className="no-thumbnail avatar md rounded-circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right-from-arc"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M15 12h-12"></path>
                  <path d="M7 8l-4 4l4 4"></path>
                  <path d="M12 21a9 9 0 0 0 0 -18"></path>
                </svg>
              </span>
            </button>
            {/* <!--[ Start:: Brand Logo icon ]--> */}
            <div className="d-flex align-items-center">
              {
                hideValue ? (
                  <svg
                    className="text-primary"
                    width="36"
                    height="36"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 21l18 0" />
                    <path d="M3 10l18 0" />
                    <path d="M5 6l7 -3l7 3" />
                    <path d="M4 10l0 11" />
                    <path d="M20 10l0 11" />
                    <path d="M8 14l0 3" />
                    <path d="M12 14l0 3" />
                    <path d="M16 14l0 3" />
                  </svg>
                ) :
                  ("")
              }

              <Link className="brand-logo fs-4 fw-semibold m-0 px-3 ps-1 text-capitalize">
                {pageTitle.charAt(0).toLocaleUpperCase() + pageTitle.slice(1)}
              </Link>
            </div>
          </div>
          <form className="ms-auto main-search me-md-4 me-sm-3 d-none d-sm-block">
            <div className="w-100">
              <svg
                className="svg-stroke search-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                <path d="M21 21l-6 -6"></path>
              </svg>
              <input
                type="text"
                className="form-control px-5 rounded-4 bg-light"
                placeholder="Search for something"
                aria-label="Search..."
              />
            </div>
          </form>
          {
            MenuShow ? (
              <ul className="header-menu">
                {/* <!--[ Start:: Dark/Light setting ]--> */}
                <li className="nav-item dropdown px-md-1">
                  <div
                    className="dropdown-toggle gray-6 no-thumbnail avatar md rounded-circle"
                    id="bd-theme"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <svg
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      className="theme-icon-active"
                    >
                      <use href={`#${iconId}`}></use>
                    </svg>
                  </div>
                  <ul
                    className="dropdown-menu dropdown-menu-end p-2 p-xl-3 shadow rounded-4"
                    aria-labelledby="bd-theme"
                  >
                    {["light", "dark", "auto"].map((mode) => (
                      <li key={mode} className="mb-1">
                        <label
                          className={`dropdown-item rounded-pill d-flex align-items-center ${selectedMode === mode ? "active" : ""
                            }`}
                        >
                          <input
                            type="radio"
                            name="theme-mode"
                            value={mode}
                            checked={selectedMode === mode}
                            onChange={() => {
                              setThemeMode(mode); // Update the theme mode
                            }}
                            className="me-2"
                            style={{ display: "none" }} // Hide the native radio button
                          />
                          <svg
                            className="avatar xs me-2 opacity-50 theme-icon"
                            fill="currentColor"
                          >
                            <use
                              href={`#${mode === "light"
                                ? "sun-fill"
                                : mode === "dark"
                                  ? "moon-stars-fill"
                                  : "circle-half"
                                }`}
                            ></use>
                          </svg>
                          {mode.charAt(0).toUpperCase() + mode.slice(1)}
                        </label>
                      </li>
                    ))}
                  </ul>
                </li>

                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style={{ display: "none" }}>
                  {/* Symbols for icons */}
                  <symbol id="sun-fill" viewBox="0 0 16 16">
                    <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z" />
                  </symbol>
                  <symbol id="moon-stars-fill" viewBox="0 0 16 16">
                    <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z" />
                    <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z" />
                  </symbol>
                  <symbol id="circle-half" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                  </symbol>
                </svg>

                {/* <!--[ Start:: theme setting ]--> */}
                <li className="nav-item dropdown px-md-1 ms-3">
                  <Link
                    className="gray-6 no-thumbnail avatar md rounded-circle "
                    data-bs-toggle="collapse"
                    to="#collapseExample"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1_2691)">
                        <path
                          d="M9.56482 18H8.43514C7.52147 18 6.77809 17.2567 6.77809 16.343V15.9608C6.38965 15.8367 6.01225 15.68 5.64968 15.4924L5.37884 15.7633C4.72286 16.42 3.67207 16.4008 3.03514 15.763L2.23671 14.9646C1.59866 14.3273 1.58031 13.2768 2.23692 12.6209L2.50755 12.3503C2.31993 11.9877 2.1633 11.6104 2.03917 11.2219H1.65702C0.743379 11.2219 0 10.4785 0 9.56485V8.43514C0 7.52147 0.743379 6.77813 1.65705 6.77813H2.0392C2.16334 6.38965 2.31996 6.01228 2.50759 5.64971L2.23675 5.37891C1.58052 4.72338 1.59863 3.67284 2.23696 3.03521L3.03546 2.23675C3.67386 1.59746 4.7244 1.5815 5.37912 2.23696L5.64971 2.50755C6.01228 2.31996 6.38968 2.1633 6.77813 2.03917V1.65702C6.77813 0.743344 7.52147 0 8.43518 0H9.56485C10.4785 0 11.2219 0.743344 11.2219 1.65702V2.0392C11.6103 2.1633 11.9877 2.31996 12.3503 2.50759L12.6211 2.23675C13.2771 1.57996 14.3279 1.59922 14.9648 2.23699L15.7633 3.03539C16.4013 3.67274 16.4197 4.72317 15.763 5.37908L15.4924 5.64971C15.68 6.01228 15.8367 6.38961 15.9608 6.77813H16.3429C17.2566 6.77813 18 7.52147 18 8.43514V9.56485C18 10.4785 17.2566 11.2219 16.3429 11.2219H15.9608C15.8367 11.6104 15.68 11.9877 15.4924 12.3503L15.7633 12.6211C16.4195 13.2767 16.4014 14.3272 15.763 14.9648L14.9645 15.7633C14.3261 16.4026 13.2756 16.4185 12.6209 15.7631L12.3503 15.4925C11.9877 15.6801 11.6103 15.8367 11.2219 15.9609V16.3431C11.2219 17.2567 10.4785 18 9.56482 18ZM5.82599 14.3849C6.32967 14.6828 6.87178 14.9078 7.43723 15.0537C7.67011 15.1138 7.83281 15.3238 7.83281 15.5643V16.343C7.83281 16.6751 8.10306 16.9453 8.43518 16.9453H9.56485C9.89698 16.9453 10.1672 16.6751 10.1672 16.343V15.5643C10.1672 15.3238 10.3299 15.1138 10.5628 15.0537C11.1283 14.9078 11.6704 14.6828 12.174 14.3849C12.3813 14.2623 12.6451 14.2957 12.8154 14.4659L13.3669 15.0175C13.6047 15.2556 13.9866 15.25 14.2186 15.0177L15.0176 14.2188C15.249 13.9877 15.2567 13.6057 15.0178 13.3671L14.466 12.8153C14.2958 12.6451 14.2624 12.3812 14.385 12.174C14.6828 11.6704 14.9078 11.1283 15.0538 10.5628C15.1139 10.3299 15.3239 10.1672 15.5644 10.1672H16.343C16.6751 10.1672 16.9453 9.89701 16.9453 9.56489V8.43518C16.9453 8.10306 16.6751 7.83285 16.343 7.83285H15.5644C15.3239 7.83285 15.1139 7.67014 15.0538 7.4373C14.9078 6.87182 14.6828 6.32971 14.385 5.82606C14.2624 5.61885 14.2958 5.35497 14.466 5.18474L15.0176 4.63317C15.256 4.39502 15.2498 4.01323 15.0178 3.78151L14.2188 2.98259C13.9873 2.7507 13.6053 2.74391 13.3672 2.98238L12.8154 3.53415C12.6452 3.70441 12.3813 3.73774 12.1741 3.61519C11.6704 3.31731 11.1283 3.09227 10.5628 2.94634C10.33 2.88626 10.1673 2.67623 10.1673 2.43573V1.65702C10.1673 1.3249 9.89701 1.05469 9.56489 1.05469H8.43521C8.10309 1.05469 7.83285 1.3249 7.83285 1.65702V2.43566C7.83285 2.67616 7.67014 2.88619 7.43727 2.94627C6.87182 3.0922 6.32971 3.31724 5.82602 3.61512C5.61874 3.73764 5.35489 3.70431 5.18467 3.53408L4.63314 2.98252C4.39534 2.74444 4.01344 2.74996 3.78151 2.98227L2.98252 3.78123C2.75112 4.01235 2.74338 4.39425 2.9823 4.63289L3.53408 5.18467C3.70431 5.35489 3.73764 5.61878 3.61512 5.82599C3.31724 6.32964 3.09224 6.87175 2.9463 7.43723C2.88619 7.67011 2.67616 7.83278 2.4357 7.83278H1.65705C1.32493 7.83281 1.05469 8.10302 1.05469 8.43514V9.56485C1.05469 9.89698 1.32493 10.1672 1.65705 10.1672H2.43566C2.67616 10.1672 2.88615 10.3299 2.94627 10.5627C3.0922 11.1282 3.31724 11.6703 3.61508 12.174C3.7376 12.3812 3.70427 12.6451 3.53405 12.8153L2.98248 13.3669C2.74405 13.605 2.75027 13.9868 2.98227 14.2185L3.7812 15.0174C4.01277 15.2493 4.39471 15.2561 4.63286 15.0177L5.1846 14.4659C5.31004 14.3405 5.571 14.2341 5.82599 14.3849Z"
                          fill="#718EBF"
                        ></path>
                        <path
                          d="M8.9999 12.9164C6.84036 12.9164 5.0835 11.1595 5.0835 8.99999C5.0835 6.84049 6.84036 5.08359 8.9999 5.08359C11.1594 5.08359 12.9163 6.84049 12.9163 8.99999C12.9163 11.1595 11.1594 12.9164 8.9999 12.9164ZM8.9999 6.13828C7.42191 6.13828 6.13818 7.42204 6.13818 8.99999C6.13818 10.5779 7.42195 11.8617 8.9999 11.8617C10.5779 11.8617 11.8616 10.5779 11.8616 8.99999C11.8616 7.42204 10.5779 6.13828 8.9999 6.13828Z"
                          fill="#718EBF"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_1_2691">
                          <rect width="18" height="18" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </Link>
                </li>
                {/* <!--[ Start:: notification ]--> */}
                <li className="nav-item dropdown px-md-1 d-none d-md-inline-flex ms-3">
                  <Link className="dropdown-toggle gray-6 no-thumbnail avatar md rounded-circle" to={location}
                    role="button" data-bs-toggle="dropdown" aria-expanded="false"
                    title="notification">
                    <span className="bullet-dot bg-primary animation-blink"></span>
                    <svg width="25" height="25" viewBox="0 0 18 18" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_1_2696)">
                        <path d="M8.23828 18C6.68811 18 5.42578 16.7385 5.42578 15.1875C5.42578 14.877 5.67778 14.625 5.98828 14.625C6.29878 14.625 6.55078 14.877 6.55078 15.1875C6.55078 16.1183 7.30829 16.875 8.23828 16.875C9.16827 16.875 9.92578 16.1183 9.92578 15.1875C9.92578 14.877 10.1778 14.625 10.4883 14.625C10.7988 14.625 11.0508 14.877 11.0508 15.1875C11.0508 16.7385 9.78859 18 8.23828 18Z"
                          fill="#FE5C73"></path>
                        <path d="M14.4257 15.75H2.05074C1.32701 15.75 0.738281 15.1613 0.738281 14.4375C0.738281 14.0534 0.905548 13.6898 1.19724 13.44C1.21605 13.4235 1.23624 13.4085 1.25725 13.3949C2.35822 12.4342 2.98828 11.052 2.98828 9.59244V7.49995C2.98828 4.60506 5.34402 2.25 8.23824 2.25C8.35826 2.25 8.48804 2.2522 8.60806 2.27252C8.91472 2.32347 9.12181 2.61378 9.07072 2.91975C9.01978 3.22572 8.72424 3.43282 8.42349 3.38173C8.36348 3.37198 8.29756 3.375 8.23824 3.375C5.96434 3.375 4.11328 5.22523 4.11328 7.49995V9.59244C4.11328 11.4045 3.31897 13.119 1.93607 14.2957C1.9248 14.3047 1.91505 14.313 1.90297 14.3212C1.88278 14.3468 1.86328 14.3858 1.86328 14.4375C1.86328 14.5394 1.94884 14.625 2.05074 14.625H14.4257C14.5278 14.625 14.6133 14.5394 14.6133 14.4375C14.6133 14.3849 14.5938 14.3468 14.5728 14.3212C14.5616 14.313 14.5518 14.3047 14.5405 14.2957C13.1568 13.1182 12.3633 11.4045 12.3633 9.59244V8.77505C12.3633 8.46455 12.6153 8.21255 12.9258 8.21255C13.2363 8.21255 13.4883 8.46455 13.4883 8.77505V9.59244C13.4883 11.0528 14.1191 12.4357 15.2216 13.3973C15.2417 13.4107 15.2612 13.425 15.2792 13.4408C15.5711 13.6898 15.7383 14.0534 15.7383 14.4375C15.7383 15.1613 15.1496 15.75 14.4257 15.75Z"
                          fill="#FE5C73"></path>
                        <path d="M13.4883 7.49995C11.4206 7.49995 9.73828 5.81781 9.73828 3.75005C9.73828 1.68228 11.4206 0 13.4883 0C15.5561 0 17.2382 1.68228 17.2382 3.75005C17.2382 5.81781 15.5561 7.49995 13.4883 7.49995ZM13.4883 1.125C12.0407 1.125 10.8633 2.30246 10.8633 3.75005C10.8633 5.19749 12.0407 6.37495 13.4883 6.37495C14.9358 6.37495 16.1132 5.19749 16.1132 3.75005C16.1132 2.30246 14.9358 1.125 13.4883 1.125Z"
                          fill="#FE5C73"></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_1_2696">
                          <rect width="18" height="18" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </Link>
                  <div className="dropdown-menu shadow rounded-4 notification" id="NotificationsDiv">
                    <div className="card border-0">
                      <div
                        className="card-header d-flex justify-content-between align-items-center py-3">
                        <h4 className="mb-0 text-gradient title-font">Notifications</h4>
                        <Link to="/" className="btn btn-link" title="view all">View all</Link>
                      </div>
                      <ul className="card-body p-0 list-unstyled mb-0 custom_scroll ps-2"
                        style={{ height: "400px" }}>
                        <li className="pe-2">
                          <Link className="d-flex p-lg-3 p-2 rounded-3"
                            to="/" onClick={(e) => e.preventDefault()}>
                            <div className="avatar sm">
                              <svg className="svg-stroke"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24" stroke="currentColor"
                                fill="none" strokeLinecap="round"
                                strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                </path>
                                <path
                                  d="M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3">
                                </path>
                              </svg>
                            </div>
                            <div className="flex-fill ms-3">
                              <span className="d-flex justify-content-between">
                                <small className="text-primary">Holiday Sale</small>
                                <small className="text-muted">11:30 AM Today</small>
                              </span>
                              <p className="mb-0 mt-1">Your New Campaign sale live on
                                themeforest and our store is approved.</p>
                            </div>
                          </Link>
                        </li>
                        <li className="pe-2">
                          <Link className="d-flex p-lg-3 p-2 rounded-3"
                            to="/" onClick={(e) => e.preventDefault()}>
                            <div className="avatar sm">
                              <svg className="svg-stroke"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24" stroke="currentColor"
                                fill="none" strokeLinecap="round"
                                strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                </path>
                                <path
                                  d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697">
                                </path>
                                <path d="M18 14v4h4"></path>
                                <path d="M18 11v-4a2 2 0 0 0 -2 -2h-2"></path>
                                <path
                                  d="M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z">
                                </path>
                                <path
                                  d="M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0">
                                </path>
                                <path d="M8 11h4"></path>
                                <path d="M8 15h3"></path>
                              </svg>
                            </div>
                            <div className="flex-fill ms-3">
                              <span className="d-flex justify-content-between">
                                <small className="text-info">Reports</small>
                                <small className="text-muted">04:00 PM Today</small>
                              </span>
                              <p className="mb-0 mt-1">Website visits from Twitter is 27%
                                higher than last week.</p>
                            </div>
                          </Link>
                        </li>
                        <li className="pe-2">
                          <Link className="d-flex p-lg-3 p-2 rounded-3 align-items-start"
                            to="/" onClick={(e) => e.preventDefault()}>
                            <img className="avatar sm rounded-circle"
                              src={avatar4} alt="avatar" />
                            <div className="flex-fill ms-3">
                              <span className="d-flex justify-content-between">
                                <small className="text-warning">HTML Code</small>
                                <small className="text-muted">1day</small>
                              </span>
                              <p className="mb-0 mt-1">Update new code in github and
                                share deteail</p>
                            </div>
                          </Link>
                        </li>
                        <li className="pe-2">
                          <div className="d-flex p-lg-3 p-2 rounded-3">
                            <img className="avatar sm rounded-circle"
                              src={avatar1} alt="avatar" />
                            <div className="flex-fill ms-3" >
                              <span className="d-flex justify-content-between">
                                <small className="text-success">New Request</small>
                                <small className="text-muted">1day</small>
                              </span>
                              <p className="mb-0 mt-1">
                                <strong>Tina Harris</strong>
                                is requesting to upgrade Plan
                              </p>
                              <div className="mt-2">
                                <Link to="/"
                                  className="btn btn-sm bg-accent text-white me-2">Accept</Link>
                                <Link to="/"
                                  className="btn btn-sm btn-dark text-white">Decline</Link>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="pe-2">
                          <Link className="d-flex p-lg-3 p-2 rounded-3"
                            to="/" onClick={(e) => e.preventDefault()}>
                            <div className="avatar sm">
                              <svg className="svg-stroke"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24" stroke="currentColor"
                                fill="none" strokeLinecap="round"
                                strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                </path>
                                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0">
                                </path>
                                <path d="M12 8v4"></path>
                                <path d="M12 16h.01"></path>
                              </svg>
                            </div>
                            <div className="flex-fill ms-3">
                              <span className="d-flex justify-content-between">
                                <small className="text-danger">Error 404</small>
                                <small className="text-muted">Yesterday</small>
                              </span>
                              <p className="mb-0 mt-1">DashBanker admin template on
                                website analytics configurations</p>
                            </div>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                {/* <!--[ Start:: user detail ]--> */}
                <li className="nav-item user ms-3">
                  <Link
                    className="dropdown-toggle gray-6 d-flex text-decoration-none align-items-center lh-sm p-0"
                    to="/"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    title="User"
                    data-bs-auto-close="outside"
                  >
                    <img
                      className="avatar rounded-circle border border-3"
                      src={UserImg}
                      alt="avatar"
                    />
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end shadow p-2 p-xl-3 rounded-4">
                    <div className="bg-body p-3 rounded-3">
                      <h4 className="mb-1 title-font text-gradient">
                        Michelle Glover
                      </h4>
                      <p className="small text-muted">michelle.glover@gmail.com</p>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Update my status"
                      />
                    </div>
                    <ul className="list-unstyled mt-3">
                      <li>
                        <Link
                          className="dropdown-item rounded-pill"
                          aria-label="my services"
                          to="/services"
                        >
                          My Services
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/privileges"
                          className="nav-link ps-0 my-2"
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          aria-label="My Privileges"
                          data-bs-original-title="My Privileges"
                        >
                          <span className="mx-3">My Privileges</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item rounded-pill"
                          aria-label="account settings"
                          to="/setting"
                        >
                          Settings
                        </Link>
                      </li>
                    </ul>
                    <Link
                      className="btn py-2 btn-primary w-100 mt-3 rounded-pill"
                      to="/signin"
                      role="button"
                    >
                      Logout
                    </Link>
                    <div className="mt-3 text-center small">
                      <Link className="text-muted me-1" to="/!">
                        Privacy policy
                      </Link>
                      <Link className="text-muted mx-1" to="/!">
                        Terms
                      </Link>
                      <Link className="text-muted ms-1" to="/!">
                        Cookies
                      </Link>
                    </div>
                  </div>
                </li>
              </ul>
            ) : ("")
          }

        </div >
        <div className="d-flex justify-content-between align-items-center py-2 w-100 d-block d-sm-none">
          <form className="main-search me-md-4 d-md-inline-flex w-100">
            <svg
              className="svg-stroke search-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
              <path d="M21 21l-6 -6"></path>
            </svg>
            <input
              type="text"
              className="form-control rounded-4 bg-light"
              placeholder="Search for something"
              aria-label="Search..."
            />
          </form>
        </div>
      </header >
      <div className="px-2">
        <CommonSetting selectedMode={selectedMode} />
      </div>
    </>
  );
};

export default CommonHeader;
